import React from 'react';

export interface TabDef {
  key: string;
  label: string;
}

function Tabs({ tabs, active, onChange }: { tabs: TabDef[]; active: string; onChange: (key: string) => void }) {
  return (
    <div role="tablist" className="flex gap-1 border-b overflow-x-auto">
      {tabs.map((t) => (
        <button
          key={t.key}
          role="tab"
          aria-selected={active === t.key}
          onClick={() => onChange(t.key)}
          className={`px-4 py-2 text-sm whitespace-nowrap border-b-2 -mb-px ${
            active === t.key
              ? 'border-primary-600 text-primary-700 font-semibold'
              : 'border-transparent text-gray-500 hover:text-gray-800'
          }`}
        >
          {t.label}
        </button>
      ))}
    </div>
  );
}

export default Tabs;
